<template>
  <div class="navbar">
    <header class="header">
      <!-- Logo -->
      <div class="logo">
        <router-link to="/" class="logo-link">
          <div class="logo-icon-wrap">
            <img :src="imgUrl" alt="logo" />
          </div>
          <div class="logo-text">
            <span class="logo-title">水产供应链服务平台</span>
            <span class="logo-sub">Aquatic Supply Chain Service Platform</span>
          </div>
        </router-link>
      </div>

      <!-- 导航菜单 -->
      <el-menu
        class="navbar-menu"
        mode="horizontal"
        :default-active="activeMenu"
        active-text-color="#1565c0"
        router>
        <div class="menu-items">
          <el-menu-item index="/home">首页</el-menu-item>
          <el-menu-item index="/purchase">采购信息</el-menu-item>
          <el-menu-item index="/supply">供应信息</el-menu-item>
          <el-menu-item index="/price">价格参考</el-menu-item>
          <el-menu-item index="/merchants">优质商户</el-menu-item>
          <el-menu-item index="/news">平台公告</el-menu-item>
          <el-menu-item index="/publish">发布信息</el-menu-item>
          <el-menu-item index="/feedback">意见收集</el-menu-item>
        </div>
      </el-menu>

      <!-- 未登录时 -->
      <div v-if="!isLogin" class="auth-area">
        <el-button class="btn-login" @click="goLogin">登录</el-button>
        <el-button class="btn-register" @click="goRegister">注册</el-button>
      </div>

      <!-- 用户信息 -->
      <div v-if="isLogin" class="user-info">
        <el-dropdown @command="handleCommand">
          <div class="user-avatar-wrap">
            <div class="user-avatar">{{ name ? name[0] : 'U' }}</div>
            <span class="user-name">{{ name }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile">
              <i class="el-icon-user"></i>
              个人中心
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              <i class="el-icon-switch-button"></i>
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>

    <!-- 底部装饰线 -->
    <!-- <div class="navbar-border"></div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import imgUrl from '@/assets/image.png'

export default {
  name: 'Navbar',
  data() {
    return {
      imgUrl
    }
  },
  computed: {
    ...mapGetters(['name', 'isLogin']),
    activeMenu() {
      const route = this.$route
      const { path, meta } = route
      if (meta.hasOwnProperty('activeMenu')) {
        return meta.activeMenu
      }
      return path
    }
  },
  methods: {
    goLogin() {
      this.$store.dispatch('authModal/openModal', {
        mode: 'login',
        returnTo: this.$route.fullPath
      })
    },
    goRegister() {
      this.$router.push('/register')
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定退出登录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$store.dispatch('user/logout').then(() => {
              this.$message.success('已退出登录')
              this.$router.push('/')
              location.reload()
            })
          })
          .catch(() => {})
      } else if (command === 'profile') {
        if (this.$route.path !== '/profile') {
          this.$router.push('/profile')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// ── 色彩变量 ──────────────────────────────
$primary: #1565c0; // 深蓝主色
$primary-light: #1e88e5; // 悬停蓝
$accent: #0288d1; // 点缀蓝（用于 active 下划线）
$bg: #ffffff;
$text-main: #1a2233;
$text-muted: #6b7a99;
$border: #e4eaf4;
$shadow: rgba(21, 101, 192, 0.08);

// ── 导航根容器 ────────────────────────────
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background: $bg;
  box-shadow: 0 2px 12px $shadow;
}

// ── 底部强调线 ────────────────────────────
.navbar-border {
  height: 3px;
  background: $accent;
  opacity: 0.85;
}

// ── 主容器 ────────────────────────────────
.header {
  display: flex;
  align-items: center;
  padding: 0 40px;
  height: 80px;
  background: $bg;
}

// ── Logo ──────────────────────────────────
.logo {
  flex-shrink: 0;
  margin-right: 32px;

  .logo-link {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;

    &:hover .logo-title {
      color: $primary-light;
    }
  }

  .logo-icon-wrap {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: #e3f0fd;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;

    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
  }

  .logo-text {
    display: flex;
    flex-direction: column;
    line-height: 1;
  }

  .logo-title {
    font-size: 17px;
    font-weight: 700;
    color: $text-main;
    letter-spacing: 0.5px;
    transition: color 0.2s;
  }

  .logo-sub {
    font-size: 11px;
    color: $text-muted;
    margin-top: 4px;
    letter-spacing: 0.3px;
    font-weight: 400;
  }
}

// ── 菜单 ──────────────────────────────────
.navbar-menu {
  flex: 1;
  border: none !important;
  background: transparent;
  height: 80px;

  .menu-items {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 10px;
  }

  :deep(.el-menu-item) {
    font-size: 0.2rem;
    font-weight: 500;
    color: $text-muted;
    height: 0.8rem;
    line-height: 0.8rem;
    // padding: 0 0.16rem;
    // border-bottom: 3px solid transparent !important;
    transition: color 0.2s, border-color 0.2s;
    background: transparent !important;

    &:hover {
      color: $primary !important;
      background: #f0f6ff !important;
      border-radius: 0.04rem;
    }

    &.is-active {
      color: $primary !important;
      font-weight: 600;
      border-bottom-color: $accent !important;
      background: transparent !important;
    }
  }
}

// ── 登录/注册 ─────────────────────────────
.auth-area {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 20px;

  .btn-login {
    height: 36px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 500;
    color: $primary;
    border: 1.5px solid $primary;
    border-radius: 6px;
    background: transparent;
    transition: all 0.2s;

    &:hover {
      background: #e8f1fb;
      border-color: $primary-light;
      color: $primary-light;
    }
  }

  .btn-register {
    height: 36px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    background: $primary;
    border: 1.5px solid $primary;
    border-radius: 6px;
    transition: all 0.2s;

    &:hover {
      background: $primary-light;
      border-color: $primary-light;
    }
  }
}

// ── 用户信息 ──────────────────────────────
.user-info {
  flex-shrink: 0;
  margin-left: 20px;
  display: flex;

  .user-avatar-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 6px 12px;
    border-radius: 6px;
    transition: background 0.2s;

    &:hover {
      background: #f0f6ff;
    }
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: $primary;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .user-name {
    font-size: 18px;
    color: $text-main;
    font-weight: 500;
    max-width: 80px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
  }

  i {
    font-size: 16px;
    color: $text-muted;
    margin-left: 26px;
  }
}

// ── 下拉菜单 ──────────────────────────────
:deep(.el-dropdown-menu__item) {
  font-size: 0.18rem !important;
  padding: 0.08rem 0.16rem;
  color: $text-main;

  i {
    margin-right: 0.06rem;
    color: $text-muted;
  }

  &:hover {
    background: #f0f6ff !important;
    color: $primary !important;

    i {
      color: $primary !important;
    }
  }
}
</style>
